import { useQuery, useMutation } from "react-apollo";
import gql from "graphql-tag";

const REFUND = gql`
  query getRefund($id: ID) {
    getRefund(id: $id) {
      id
      store {
        id
        name
      }
      client {
        lastName
        firstName
      }
      command {
        florist {
          id
          name

          photoUrl
          address
          city
          storeCountry {
            name
          }
          siret
        }

        state
        captured
        delivrable
        status {
          state
          date
        }
        promotion {
          id
          code
          value
          promotionType
          enabled
          discountType
        }

        oldItems {
          _id
          variant {
            id
            product
            refVariation

            price
            weight
            values {
              label
              value
            }
          }
          product {
            id
            name
            photoUrls {
              photoUrl
            }
            enableSimpleProduct
            enableMultiVariation
            enableAddons
          }
          quantity
          promotion {
            id
            title
            value
            promotionType
          }
        }
        items {
          _id
          variant {
            id
            product
            refVariation

            price
            weight
            values {
              label
              value
            }
          }
          product {
            id
            name
            photoUrls {
              photoUrl
            }
            enableSimpleProduct
            enableMultiVariation
            enableAddons
          }
          quantity
          promotion {
            id
            title
            value
            promotionType
          }
        }
        client {
          id
          firstName
          lastName
          tel
          fullName
          profile {
            email
          }
          photoUrl
        }
        deliveryAddress {
          firstName
          lastName
          address
          deliveryMode
          address1
          phone
          descrption
        }
        num
        createdAt
        totalPrice
        subtotalPrice
        deliveryMode
        paymentMethods
        deliveryTime
        deliveredBy
        paymentMode
        paymentState
        deliveryFee
        feeService
        totalTax
        message
        commission
        deliveryCancellationRaison {
          raison
          canceledDate
          canceledBy
          refunded
        }
        canceledBy {
          role
          name
          canceledDate
          raison
        }
        oldTotalPrice
        oldSubtotalPrice
        oldDeliveryFee
        reshaped
      }
      refunded
      refundedAt
      comment
      refundMethod
    }
  }
`;

const MARK_AS_REFUNDED = gql`
  mutation markAsRefund(
    $id: ID
    $refundedAt: Float
    $amount: Float
    $comment: String
    $refundMethod: String
  ) {
    markAsRefund(
      id: $id
      refundedAt: $refundedAt
      amount: $amount
      comment: $comment
      refundMethod: $refundMethod
    ) {
      id
      store {
        id
        name
      }
      client {
        lastName
        firstName
      }
      command {
        id
        num
        totalPrice
        reshaped
        oldTotalPrice
      }
      refunded
    }
  }
`;

export const useMutationRefund = () => {
  const [update] = useMutation(MARK_AS_REFUNDED);

  function markAsRefund({ id, refundedAt, comment, refundMethod, amount }) {
    return update({
      variables: { id, refundedAt, comment, refundMethod, amount },
      fetchPolicy: "no-cache",
    });
  }

  return {
    markAsRefund,
  };
};

export const useQueryRefund = (id) => {
  const { data, ...rest } = useQuery(REFUND, {
    variables: {
      id,
    },
    fetchPolicy: "no-cache",
  });

  return { data: data?.getRefund, ...rest };
};
